import { Switch } from '@audio-network/componentlibrary'
import { Stems } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'
import { useFormContext } from 'react-hook-form'

import { useDownloadContext } from '../../DownloadOptionsModal.context'
import { ADD_ALL_STEMS_FIELD } from '../DownloadOptions.constants'
import downloadOptionsStyles from '../DownloadOptions.module.css'
import {
	getFileTypeFromOptionValue,
	getNoStemsMessageKey,
	getStemFileCount,
	hasStemsOnTracks,
} from '../DownloadOptions.utils'
import FieldsetSection from '../FieldsetSection'

const StemsOptionsSection = (): JSX.Element => {
	const { downloadOptions, modalId, initialTracks } = useDownloadContext()
	const { register, watch } = useFormContext()
	const { t } = useTranslation('download')
	const hasStems = hasStemsOnTracks(initialTracks)
	const stemsSelected = Boolean(watch(ADD_ALL_STEMS_FIELD))
	const fileType = getFileTypeFromOptionValue(
		modalId,
		String(watch('fileFormat') ?? '')
	)
	const showStemsDownloadAsWav = stemsSelected && fileType !== 'wav'
	const stemFileCount = getStemFileCount(downloadOptions?.stems)

	return (
		<FieldsetSection
			legendIcon={<Stems className={downloadOptionsStyles.stemOptionsIcon} />}
			title={t('stem-options')}
		>
			{hasStems ? (
				<>
					<Switch
						className={downloadOptionsStyles.switch}
						id={`${modalId}-${ADD_ALL_STEMS_FIELD}`}
						label={
							<span className={downloadOptionsStyles.label}>
								<span className={downloadOptionsStyles.labelDescription}>
									{t('add-all-track-stems')}
								</span>
								{stemFileCount > 0 && (
									<>
										{' '}
										<span className={downloadOptionsStyles.meta}>
											{stemFileCount}
										</span>
									</>
								)}
							</span>
						}
						{...register(ADD_ALL_STEMS_FIELD)}
					/>
					{showStemsDownloadAsWav && (
						<span
							className={downloadOptionsStyles.stemsWavMessage}
							id={`${modalId}-stems-wav`}
						>
							{t('stems-will-download-as-wav-files')}
						</span>
					)}
				</>
			) : (
				<span>{t(getNoStemsMessageKey(initialTracks.length))}</span>
			)}
		</FieldsetSection>
	)
}

export default StemsOptionsSection
